import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NOTES_CONTROLS } from '../on-demand-pickup.constants';
import { CONSTANTS } from './notes-section.constants';

@Component({
  selector: 'app-notes-section',
  templateUrl: './notes-section.component.html',
  styleUrls: ['./notes-section.component.scss'],
  standalone: false,
})
export class NotesSectionComponent {
  @Input({ required: true }) form!: FormGroup;

  readonly CONSTS = CONSTANTS;
  readonly CONTROLS = NOTES_CONTROLS;
}
